<template>
    <app-ghost-mode>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4 col-sm-6 col-12 offset-md-4 offset-sm-3 offset-0 my-5">
                    <div class="auth-box p-5">
                        <form>
                            <h3 class="text-center">Business Phone <i class="fas fa-mobile-alt fa-sm text-dark-green"></i></h3>
                            <!-- Alert Messages -->
                            <div v-if="msg !== ''" :class="`alert alert-${color} text-center mb-n2 mt-3 p-1`" role="alert">
                                <i class="fas fa-exclamation-circle"></i> {{ msg }}
                            </div>
                            <div class="mt-3">
                                <div class="text-center mb-2">
                                    <small>
                                        Items posted with a visible business phone number tends to sell faster. 
                                        Buyers can easily reach you and aNewItem can notify you when you have a new buyer. 
                                        Interested? Enter phone number
                                    </small>
                                </div>
                                <div v-if="previewPhone" class="my-1 p-1 text-dark-green bg-white">
                                    <i class="fas fa-phone-alt fa-sm"></i> Your Phone No.: {{user.phoneCode}}{{phone}}
                                </div>
                                <div class="input-group">
                                    <div v-if="user.phoneCode" class="input-group-prepend">
                                        <div class="input-group-text bg-light"><i :class="`flag flag-${user.alphaCode} mr-2`"></i>{{user.phoneCode}}</div>
                                    </div>
                                    <input type="phone" v-model="phone" ref="phone" @keyup="previewPhone = true" placeholder="phone number" class="form-control no-lines">
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-6">
                                            <button @click.prevent="skipPhoneBox" class="btn btn-light-green btn-sm form-control">Skip</button>
                                        </div>
                                        <div class="col-6">
                                            <button @click.prevent="saveBio" class="loadn btn btn-dark-green btn-sm form-control">Save Phone</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-12 text-center">
                                    <small>
                                        You can always turn this off in
                                        <router-link :to="{ name: 'settings', query: { privacy: null } }" class="text-dark-green clickable">
                                            Privacy Settings
                                        </router-link>.
                                    </small>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </app-ghost-mode>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import GhostMode from '@/components/general/shared/GhostMode.vue'

export default {
    name: "ValidatePhone",
    data() {
        return {
            msg: '',
            color: 'danger',
            phone: '',
            previewPhone: false,
        }
    },
    methods: {
        ...mapActions(['updateProfile']),
        saveBio() {
            this.color = "danger"
            if(this.phone === ''){ this.msg = "Enter your business phone number"; return }
            let userObj = {
                userId: this.user._id,
                phone: this.removePlusSign(this.phone),
            }
            this.updateProfile(userObj)
            .then(() => {
                this.color = "success"
                this.msg = "Business phone number successfully saved!"
                this.phone = ""
                this.previewPhone = false
            }).catch((e) => {
                this.msg = "Saving business phone number failed, try again."
            })
        },
        removePlusSign(val) {
            // ensure it doesn't begin with + sign
            let thePhoneCode = this.user.phoneCode ? `${this.user.phoneCode}` : '+'
            val = val.toLowerCase()
            let plusSymbol = val.slice(0, thePhoneCode.length) 
            // remove country phone code if any
            if(plusSymbol == `${this.user.phoneCode}`){ 
                return val.slice(thePhoneCode.length, val.length) 
            }
            // remove plus sign if any
            else if(val.slice(0, 1) == "+") {
                return val.slice(1, val.length) 
            }
            // return the phone number without modifying it
            else { 
                return val 
            }
        },
        skipPhoneBox() {
            this.$emit('skipPhoneFxn', true)
        }
    },
    computed: {
        ...mapGetters(['user']),
    },
    components: {
        appGhostMode: GhostMode
    },
    mounted() {
        if(this.user && !this.user.countryConfirmed){
            this.updateMyCountry()
        }
        this.$refs.phone.focus()
    }
}
</script>